import React, { memo } from 'react';
import { useLocation } from 'react-router-dom';
import { PaginationTemplate } from '../../components/templates';
import services from '../../services';
import AtivosItem from './_components/AtivosItem';
import AtivosFilter from './_components/AtivosFilter';
import AtivosMercadoTerms from './_components/AtivosMercadoTerms';
import AtivosMercadoFilter from './_components/AtivosMercadoFilter';
import { ROUTES_MERCADOS } from '../../enums';
import { getAtivosFilterConfig } from '../../utils/ativosFilterRegistry';
import { sanitizeAtivosListParams } from './_shared/ativosFilterQuery';

/** Monta a ordenação final enviada à API a partir da opção primária validada. */
function pvResolveListSort(pSort, pHasSearch) {
  if (pSort) {
    const xTieBreaker = pSort.startsWith('ativo ')
      ? 'relevancia DESC'
      : 'relevancia DESC, ativo ASC';

    return `${pSort}, ${xTieBreaker}`;
  }

  return pHasSearch
    ? 'relevancia DESC, __mr__ DESC, mercado ASC, ativo ASC'
    : 'relevancia DESC, mercado ASC';
}

const AtivosMercado = memo(props => {
  const location = useLocation();
  const pathnameBase = location.pathname.split('/')[2];
  const xMercado = ROUTES_MERCADOS[pathnameBase]?.id || null;
  const xFilterConfig = getAtivosFilterConfig(xMercado);
  /**
   * Aplica o contrato da rota antes de encaminhar os parâmetros à listagem.
   */
  function pvList(pParams, pResolve, pReject, pFinally) {
    const xParams = sanitizeAtivosListParams(pParams, xMercado);

    xParams.sort = pvResolveListSort(xParams.sort, Boolean(xParams.pesquisa));

    return services.pesquisas.ativo(xParams, pResolve, pReject, pFinally);
  }

  return (
    <PaginationTemplate
      id="ativos"
      title={ROUTES_MERCADOS[pathnameBase].descricao || 'Ativos'}
      description={
        ROUTES_MERCADOS[pathnameBase].metadata.description ||
        'Listas de ativos do mercado financeiro! Fundos, títulos públicos, títulos bancários, ações, fundos imobiliários, BDRs, ETFs, tesouro direto e outros mais.'
      }
      dataRead={pvList}
      dataReadParams={{
        cancelado: 'null',
        mercado: xMercado
      }}
      filterComponent={xFilterConfig ? AtivosMercadoFilter : AtivosFilter}
      filterVariant={xFilterConfig ? 'searchFilters' : 'legacy'}
      termsComponent={AtivosMercadoTerms}
      listItem={AtivosItem}
      listItemKey="ifeed_ativo_id"
      listItemProps={{ showAtivoTipo: true }}
      match={`${location.pathname}/*`}
      maxWidth="xl"
    />
  );
});
PaginationTemplate.displayName = 'PaginationTemplate';
export default AtivosMercado;
